export default __webpack_public_path__ + "static/media/bronz.691dd06d.png";